module.exports = __webpack_public_path__ + "static/media/icon_contacts.9e3f356f.svg";